module.exports = __webpack_public_path__ + "static/media/covid-19-wearing-masks-news.99ae631b.jpg";